
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom'
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import './ReferralForm.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import Container from 'react-bootstrap/Container';

const sgMail = require('@sendgrid/mail')
sgMail.setApiKey("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")

function ReferralForm() {

    const params = useParams();
    console.log('Params:', Number(params.id))

    const [clientManagerAgreement, setNewClientManagerAgreement] = useState(false);
    const [referralName, setNewReferralName] = useState('');
    const [referralEmail, setNewReferralEmail] = useState('');
    const [clientName, setNewClientName] = useState('');
    const [clientEmail, setNewClientEmail] = useState('');
    const [clientPhoneType, setNewClientPhoneType] = useState('');
    const [clientPhoneNumber, setNewClientPhoneNumber] = useState();
    const [clientAddress, setNewClientAddress] = useState('');
    const [clientNewsletter, setNewClientNewsletter] = useState(false);
    const [clientGender, setNewClientGender] = useState('');
    const [clientVeteran, setNewClientVeteran] = useState();
    const [clientRace, setNewClientRace] = useState();
    const [clientMaritalStatus, setNewClientMaritalStatus] = useState();
    const [clientEducation, setNewClientEducation] = useState();
    const [clientDisabled, setNewClientDisabled] = useState(1);
    const [clientHeadHousehold, setNewClientHeadHousehold] = useState();
    const [clientIncome, setNewClientIncome] = useState();
    const [clientHouseholdNumber, setNewClientHouseholdNumber] = useState();
    const [clientRequestedItems, setNewClientRequestedItems] = useState();
    const [clientConsent, setNewClientConsent] = useState();
    const [clientReason, setNewClientReason] = useState();
    const [clientReasonTxt, setNewClientReasonTxt] = useState('')
    const [clientDob, setNewClientDob] = useState('');
    const [referralDate, setNewReferralDate] = useState('')
    const [familyAges, setNewFamilyAges] = useState('');
    const [childrenNumber, setChildrenNumber] = useState('');
    const [clientAge, setNewClientAge] = useState();
      const msg = {
            to: 'miltonfernandez17@yahoo.com',
            from: 'miltonfernandez17@yahoo.com',
            subject: `this is a test`,
            text: `this a test`,
            html: '<strong>this is a test</strong>',
        }

    const dispatch = useDispatch();
    const history = useHistory()

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(clientManagerAgreement);
        const familyAgeArray = familyAges.split(' ').map(Number);
        console.log(familyAgeArray)
        if (clientManagerAgreement == true && clientConsent == true 
            && referralName != undefined && referralName != ''
            && clientEmail != '' && clientPhoneType != '' && clientPhoneNumber != undefined && clientAddress != ''
            && clientGender != '' && clientVeteran != undefined && clientRace != undefined && clientMaritalStatus != ''
            && clientEducation != undefined && clientMaritalStatus != undefined && clientDisabled != undefined && clientIncome != undefined
            && clientReason != undefined
            ) {
            console.log("manager agrees");
            console.log(referralName);
            console.log(referralEmail);
            console.log(clientName);
            console.log(clientEmail);
            console.log(clientPhoneNumber);
            console.log(clientPhoneType);
            console.log(clientAddress);
            console.log(clientGender);
            console.log(clientRace);
            console.log(clientMaritalStatus);
            console.log(clientEducation);
            console.log(clientVeteran);
            console.log(clientDisabled);
            console.log(clientHeadHousehold);
            console.log(clientIncome);
            console.log(clientRequestedItems);
            console.log(clientReason);
            console.log(clientReasonTxt);
            console.log(clientConsent);
            console.log(referralDate);

            console.log('---------------------');
            console.log(clientNewsletter);
            console.log(typeof clientNewsletter);
                


            dispatch({
                type: 'ADD_REQUEST_DATA',
                payload: {
                    clientNewsletter: clientNewsletter,
                    clientName: clientName,
                    clientEmail: clientEmail,
                    clientPhone: clientPhoneNumber,
                    clientPhoneType: Number(clientPhoneType),
                    clientAddress: clientAddress,
                    clientDob: Number(clientAge),
                    clientGender: Number(clientGender),
                    clientRace: Number(clientRace),
                    clientMaritalStatus: Number(clientMaritalStatus),
                    clientEducation: Number(clientEducation),
                    clientVeteranStatus: Number(clientVeteran),
                    clientAbility: Number(clientDisabled),
                    clientHeadOfHousehold: clientHeadHousehold,
                    clientHouseholdMembers: familyAgeArray,
                    childrenNumber: childrenNumber,
                    clientMonthlyIncome: Number(clientIncome),
                    clientReason: Number(clientReason),
                    clientReasonText: clientReasonTxt,
                    staffName: referralName,
                    staffEmail: referralEmail,
                    requestedItems: clientRequestedItems,
                    referralPartnerId: Number(params.id),
                }
            })

         
         

            dispatch({ type: 'FETCH_REQUESTS' });
            history.push('/referralcomplete');

        }
        else if (clientManagerAgreement == false || clientManagerAgreement == undefined) {
  
            Swal.fire({ title: 'Form Incomplete',
                     
                         icon: 'warning'
                    
                    })
        }
        else {
            Swal.fire({ title: 'Form Incomplete',
                     
                         icon: 'warning'
                    
                    })
        }
    }





    return (
        <>
       
      
        <div class="jumbotron  p-3 text-left">
      
            <form onSubmit={handleSubmit}>
            
            <div  class="form-group">

              <label for="clientManagerAgreementTrue" class=" col-form-label"> 
              1. We appreciate your partnership in supporting the needs of the people in our community.<br></br>
            This form is intended for partners of Furniture Mission of the Red River Valley only.<br></br>
            Only referrals submitted from identified agencies will be considered. If you are a member<br></br>
            of one of these agencies and you are aware of someone in the community who has a need for<br></br>
            clean, "gently used" furniture, please fill out the referral form on behalf of your client.<br></br>
            Referral requests are treated with the utmost discretion to protect client privacy.Referral <br></br>
            requests will be serviced according to eligibility and available supply. Client should call <br></br>
            Furniture Mission within 72 hours to schedule an appointment with the warehouse within 72 hours of approval.*<br></br>
            </label>


            <div class="form-check">
                 <label class ="form-check-label" >
                <input type="radio" class="form-check-input" id="clientManagerAgreementTrue" value="true" onChange={event => setNewClientManagerAgreement(true)} name="agreement"></input> 
                I, client manageer, agree to fill accurate and provide timely feedback to the client on approval status.
                </label>
            </div>
             <br></br>
               <div class="form-check">
                 <label class ="form-check-label" >
                <input type="radio" class="form-check-input" id="clientManagerAgreementFalse" value="false" onChange={event => setNewClientManagerAgreement(false)} name="agreement"></input>
                    I, client manager, do not agree.
                </label>
            </div>

                <br></br>
       
                <hr />



        <div class="form-group">
            <label for ="staffName" class=" col-form-label">2. Staff Member Name:*</label>
                <div class="col-sm-10">
                    <input id ="staffName" type="text" class="form-control " placeholder="Enter your answer" value={referralName} onChange={event => setNewReferralName(event.target.value)} ></input>
                </div>
        </div>
                <br></br>
                <hr />


        <div class="form-group">
            <label for ="staffEmail" class=" col-form-label">3. Staff member email, (approvals will be sent to this email address):*</label>
                <div class="col-sm-10">
                    <input id ="staffEmail" type="text" class="form-control" placeholder="Enter your answer" value={referralEmail} onChange={event => setNewReferralEmail(event.target.value)}></input>
                </div>
        </div>
                <br></br>
                <hr />


        <div class="form-group">
            <label for ="clientName" class=" col-form-label"> 4. Client name (First, Middle Initial, Last)*</label>
                <div class="col-sm-10">
                    <input for ="clientName" type="text"   class="form-control " placeholder="Enter your answer" value={clientName} onChange={event => setNewClientName(event.target.value)}></input>
                </div>
        </div>
                <br></br>
                <hr />


        <div class="form-group">
            <label for ="clientEmail" class=" col-form-label">  5. Client email (when applicable)*</label>
                <div class="col-sm-10">
                    <input for ="clientEmail" type="text" class="form-control" placeholder="Enter your answer" value={clientEmail} onChange={event => setNewClientEmail(event.target.value)}></input>
                </div>
        </div>
                <br></br>
                <hr />




             <label for="phone" class=" col-form-label"> 
                    6. Phone number type:*
            </label>

                <div class="form-check">
                    <label class ="form-check-label" >
                        <input type="radio" class="form-check-input" id="cell" value="0" name="phone" onChange={event => setNewClientPhoneType(event.target.value)}></input> 
                        Cell
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" >              
                        <input type="radio"  class="form-check-input" id="work" value="1" name="phone" onChange={event => setNewClientPhoneType(event.target.value)}></input> 
                            Work
                       </label>
                </div>  

                 <div class="form-check">
                    <label class ="form-check-label" >            
                        <input type="radio" class="form-check-input" id="home" value="2" name="phone" onChange={event => setNewClientPhoneType(event.target.value)}></input> 
                            Home
                    </label>
                </div>   


                 <div class="form-check">
                    <label class ="form-check-label" >   
                        <input type="radio" class="form-check-input"  id="other" value="3" name="phone" onChange={event => setNewClientPhoneType(event.target.value)}></input> 
                        Please do not communicate via phone with this client
                    </label>
                </div>                  
                
                <br></br>
                <hr />



        <div class="form-group">
            <label for ="clientPhone" class=" col-form-label"> 7. Client phone number (digits only, no dashes or spaces)*</label>
                <div class="col-sm-10">
                    <input id="clientPhone" type="number" class="form-control" placeholder="Must be a number" value={clientPhoneNumber} onChange={event => setNewClientPhoneNumber(event.target.value)}></input>
                </div>
        </div>            
                <br></br>
                <hr />

 
        <div class="form-group">
            <label for ="clientAddress" class=" col-form-label"> 8. Client Address (include street address, city, state, zip code)*</label>
                <div class="col-sm-10">
                    <input type="text" id="clientAddress" class="form-control" placeholder="Enter your answer" value={clientAddress} onChange={event => setNewClientAddress(event.target.value)}></input>
                </div>
        </div>
                <br></br>
                <hr />



    
            <label for="newsletter" class=" col-form-label"> 
                    9. May we add the client to our newsletter using email address provided?*
            </label>
                <div class="form-check">
                    <label class ="form-check-label" >
                        <input type="radio"  class="form-check-input" id="newsletteraccept" value={true} name="newsletter" onChange={event => setNewClientNewsletter(true)}></input> 
                    Yes
                    </label>
                </div>
                <div class="form-check">
                    <label class ="form-check-label" >
                        <input type="radio" class="form-check-input" id="newsletterdecline" value={false} name="newsletter" onChange={event => setNewClientNewsletter(false)}></input> 
                      No
                    </label>
                </div>
                <br></br>
                <hr />


            <label for="gender" class=" col-form-label"> 
                    10. Client's gender*
            </label>
                <div class="form-check">
                    <label class ="form-check-label" >
                        <input type="radio" class="form-check-input" id="female" value="0" name="gender" onChange={event => setNewClientGender(event.target.value)}></input> 
                        Female
                    </label>
                </div>

                <div class="form-check">
                    <label class ="form-check-label" >
                        <input type="radio" id="male" class="form-check-input" value="1" name="gender" onChange={event => setNewClientGender(event.target.value)}></input> 
                        Male
                     </label>
                </div>

                  <div class="form-check">
                    <label class ="form-check-label" >             
                        <input type="radio" class="form-check-input" id="genderOther" value="2" name="gender" onChange={event => setNewClientGender(event.target.value)}></input> 
                            Other
                        </label>
                </div>

                  <div class="form-check">
                    <label class ="form-check-label" >   
                            <input type="radio" class="form-check-input" id="genderPreferNotToRespond" value="3" name="gender" onChange={event => setNewClientGender(event.target.value)}></input> 
                            Prefer Not To Respond
                    </label>
                </div>
                <br></br>
                <hr />

                
            <div class="form-group">
                <label for ="clientNumber" class=" col-form-label">  11. Client's Age* </label>
                    <div class="col-sm-10">
                        <input id="clientNumber" type="number" class="form-control" placeholder="Must be a number" value={clientAge} onChange={event => setNewClientAge(event.target.value)}></input>
                    </div>
            </div>        
                <br></br>
                <hr />


   
            <label for="veteran" class=" col-form-label"> 
                     12. Client's Veteran status*
            </label>
                <div class="form-check">
                    <label class ="form-check-label" >
                        <input class="form-check-input"type="radio" id="veteranTrue" value="0" name="veteran" onChange={event => setNewClientVeteran(event.target.value)}></input> 
                           Yes
                    </label>
                </div>

                <div class="form-check">
                    <label class ="form-check-label" >
                        <input class="form-check-input" type="radio" id="veteranFalse" value="1" name="veteran" onChange={event => setNewClientVeteran(event.target.value)}></input > 
                    No
                    </label>
                </div>

                <div class="form-check">
                    <label class ="form-check-label" >
                        <input class="form-check-input" type="radio" id="veteranP" value="2" name="veteran" onChange={event => setNewClientVeteran(event.target.value)}></input> 
                            Prefer Not To Respond
                    </label>
                </div>
                <br></br>
                <hr />




                <label for="race" class=" col-form-label"> 
                     13. Client's Race*
                </label>
                <div class="form-check">
                    <label class ="form-check-label" >
                        <input   class="form-check-input" type="radio" id="americanIndian" value="0" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                        American Indian
                    </label>
                </div>

                  <div class="form-check">
                    <label class ="form-check-label" >            
                        <input  class="form-check-input" type="radio" id="africanAmerican" value="1" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                        African American or Black
                      </label>
                </div>


                  <div class="form-check">
                    <label class ="form-check-label" >  
                            <input class="form-check-input" type="radio" id="aisan" value="2" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                            Asian
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="native" value="3" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                        Native Hawaiian or Pacific Islander
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="latin" value="4" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                        Latin/Latinx
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" >               
                        <input class="form-check-input" type="radio" id="white" value="5" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                        White
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="raceOther" value="6" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                        Other
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="raceP" value="7" name="race" onChange={event => setNewClientRace(event.target.value)}></input> 
                        Prefer not to respond
                    </label>
                </div>
                <hr />


                <label for="maritalStatus" class=" col-form-label"> 
                      14. Marital Status*
                </label>
                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="separated" value="0" name="maritalStatus" onChange={event => setNewClientMaritalStatus(event.target.value)}></input>  
                        Separated
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="divorced" value="1" name="maritalStatus" onChange={event => setNewClientMaritalStatus(event.target.value)}></input>  
                        Divorced
                    </label>
                </div>

                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="widowed" value="2" name="maritalStatus" onChange={event => setNewClientMaritalStatus(event.target.value)}></input>  
                        Widowed
                    </label>
                </div>

                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="single" value="3" name="maritalStatus" onChange={event => setNewClientMaritalStatus(event.target.value)}></input>  
                        Single
                    </label>
                </div>

                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="married" value="4" name="maritalStatus" onChange={event => setNewClientMaritalStatus(event.target.value)}></input> 
                        Married
                     </label>
                </div>

                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="msP" value="5" name="maritalStatus" onChange={event => setNewClientMaritalStatus(event.target.value)}></input>  
                        Prefer Not To Respond
                    </label>
                </div>          
                
                <br></br>
                <hr />

  
                <label for="maritalStatus" class=" col-form-label"> 
                      15. Highest level of education attained by client*
                </label>

                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="lessthanhighschool" value="0" name="education" onChange={event => setNewClientEducation(event.target.value)} ></input> 
                        Less than High School
                    </label>
                </div>  
                

                <div class="form-check">
                    <label class ="form-check-label" >      
                        <input class="form-check-input" type="radio" id="highschool" value="1" name="education" onChange={event => setNewClientEducation(event.target.value)}></input> 
                        High School diploma/GED
                    </label>
                </div>  

                <div class="form-check">
                    <label class ="form-check-label" >  
                        <input class="form-check-input" type="radio" id="technical" value="2" name="education" onChange={event => setNewClientEducation(event.target.value)}></input> 
                        Technical Certification
                    </label>
                </div> 

                <div class="form-check">
                    <label class ="form-check-label" >  
                        <input class="form-check-input" type="radio" id="somecollege" value="3" name="education" onChange={event => setNewClientEducation(event.target.value)}></input> 
                        Some College
                    </label>
                </div> 

                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="collegedegree" value="4" name="education" onChange={event => setNewClientEducation(event.target.value)}></input> 
                        College Degree
                    </label>
                </div> 

                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="graduate" value="5" name="education" onChange={event => setNewClientEducation(event.target.value)}></input> 
                        Graduate Degree
                     </label>
                </div> 

                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="educationP" value="6" name="education" onChange={event => setNewClientEducation(event.target.value)}></input> 
                        Prefer not to respond
                      </label>
                </div> 
                <hr />


                <label for="disabled" class=" col-form-label"> 
                     16. Is the client disabled?*
                </label>
                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="disabledTrue" value="0" name="disabled" onChange={event => setNewClientDisabled(event.target.value)}></input> 
                        Yes
                       </label>
                </div>                
                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="disabledFalse" value="1" name="disabled" onChange={event => setNewClientDisabled(event.target.value)}></input> 
                        No
                      </label>
                </div>                  
                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="disabledP" value="2" name="disabled" onChange={event => setNewClientDisabled(event.target.value)}></input> 
                        Prefer not to respond
                    </label>
                </div>               
                <br></br>
                <hr />


                <label for="household" class=" col-form-label"> 
                     17. Is the client considered  head of household?*
                </label>
                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" id="householdTrue" value={true} name="household" onChange={event => setNewClientHeadHousehold(true)}></input> 
                        Yes
                     </label>
                </div>                  



                 <div class="form-check">
                    <label class ="form-check-label" > 
                        <input type="radio" class="form-check-input" id="householdFalse" value={false} name="household" onChange={event => setNewClientHeadHousehold(false)}></input> 
                            No
                    </label>
                </div>  

                <br></br>
                <hr />


        
           <div class="form-group">
                <label for ="clientMonthly" class=" col-form-label">   18. Household Gross Monthly Income:* </label>
                    <div class="col-sm-10"> 

                <input id="clientMonthly" class="form-control" type="number" placeholder="Must be a number" value={clientIncome} onChange={event => setNewClientIncome(event.target.value)}></input>  
                     </div>
            </div>                  
                
                <br></br>
                <hr />

            <div class="form-group">
                <label for="ages" class=" col-form-label"> 
                       19. Age of each Family Member that reside in the home(separate each family member age with a space)*
                </label>
                    <div class="col-sm-10"> 
                                                       
                        <input type="text"  class="form-control" id="ages" name="ages" value={familyAges} onChange={event => setNewFamilyAges(event.target.value)} ></input>
                    </div>
              </div>
                
                
                <br></br>
                <hr />

            <div class="form-group">
                <label for="childrenNumber" class=" col-form-label"> 
                       20. How many children under the age of 18 live in the home?*
                </label>
                    <div class="col-sm-10"> 
                        <input type="text" class="form-control" id="childrenNumber" name="childrenNumber" placeholder="Enter your answer" value={childrenNumber} onChange={event => setChildrenNumber(event.target.value)}></input>
                    </div>
            </div>
                
                <br></br>
                <hr />

                
                <div class="form-group">
                    <label for ="items" class=" col-form-label">     21. Requested items, please list by room:
                    (Bedroom, kitchen, living room,etc)*</label>
                        <div class="col-sm-10"> 
                            <input type="text"  class="form-control" id="items" placeholder="Enter your answer" value={clientRequestedItems} onChange={event => setNewClientRequestedItems(event.target.value)}></input>
                        </div>
                </div>
                <br></br>
                <hr />

   

 
                <label for="reason" class=" col-form-label"> 
                                22. Please indicate the event that is most applicable for the reason you are in need of  furniture.
                    If other, please specify.*
                </label>
                <div class="form-check">
                    <label class ="form-check-label" > 
                            <input class="form-check-input"  type="radio" id="fire" value="0" name="reason" onChange={event => setNewClientReason(event.target.value)}></input> 
                            Fire
                       </label>
                </div> 

                <div class="form-check">
                    <label class ="form-check-label" > 
                            <input class="form-check-input"  type="radio" id="flood" value="1" name="reason" onChange={event => setNewClientReason(event.target.value)}></input> 
                            Flood
                          </label>
                </div> 
                
                <div class="form-check">
                    <label class ="form-check-label" > 
                            <input class="form-check-input"  type="radio" id="restarting" value="2" name="reason" onChange={event => setNewClientReason(event.target.value)}></input> 
                            Restarting Life
                          </label>
                </div> 
                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input class="form-check-input" type="radio" class="form-check-input"  id="reasonOther" value="3" name="reason" onChange={event => setNewClientReason(event.target.value)}></input>
                        <input type="text" value={clientReasonTxt} onChange={event => setNewClientReasonTxt(event.target.value)} placeholder="Other"></input>
                    </label>
                </div>               
                
                <br></br>
                <hr />



                
                <label for="consent" class=" col-form-label"> 
                      23. Please read to the client: <br /> <br />
                    The Furniture Mission of Red River Valley is a partner in the community relying on our referral partner.<br></br>
                    The partnership is a collaboration between multiple agencies, working together to build a systematic infrastructure<br></br>
                    to coordinate basic need services for individuals and families in a more efficient, effective, and caring manner. <br></br>
                    This agency is required to collect your personal information directly from you to collect data for Furniture Mission <br></br>
                    of the Red River Valley. The information this agency collects about you will be used to improve services to you, <br></br>
                    better understand your needs, and document why they need continued funding to operate their programs.<br></br>
                    <br></br>
                    You understand the collection and use of all your personal information is protected by strict standards of<br></br>
                    confidentiality, this agency cannot provide specific legal advice regarding your rights on any of this<br></br>
                    information. You also understand that your personal information will only be disclosed in accordance with<br></br>
                    applicable federal or North Dakota state laws.*<br></br>

                    **Does the client consent**
                </label>
                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input type="radio" class="form-check-input" id="consentTrue" value={true} name="consent" onChange={event => setNewClientConsent(true)}></input> <label for="consentTrue">Yes</label>
                     </label>
                </div>                  
                <div class="form-check">
                    <label class ="form-check-label" > 
                        <input type="radio" class="form-check-input" id="consentFalse" value={false} name="consent" onChange={event => setNewClientConsent(false)}></input><label for="consentFalse">No</label>
                    </label>
                </div>   
                <br></br>


                <button class="btn btn-primary" type="submit">Submit Referral Request</button>
            </div>
            </form>
       
        </div>
    
        </>
    );
}

export default ReferralForm;